<template>
    <el-dialog
        title="供应商评分表"
        class="key-data-trans-legal-dialog"
        :append-to-body="true"
        :visible.sync="visible"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :show-close="!confirmLoading && !pdfTransforming"
        ref="dialogRef"
        width="98%"
        top="3vh"
        :before-close="close"
    >
        <div v-loading="loading" class="content-wrap" ref="contentRef">
            <div class="title-container">
                <span class="title">供应商基础信息</span>
            </div>
            <BaseInfo ref="biRef" :pdfTransforming="pdfTransforming" type="warehouse" />
            <div class="title-container">
                <span class="title">资质和合规信息</span>
            </div>
            <el-table :data="qlfTableData" :span-method="arraySpanMethod" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="businessType" label="业务类型" width="120"></el-table-column>
                <el-table-column prop="propertyNature" label="主体性质" width="120"></el-table-column>
                <el-table-column prop="zzlx" label="资质类型">
                    <template slot-scope="scope">
                        <div style="white-space: pre-wrap;">{{ scope.row.zzlx }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="qualificationFlag" label="是否符合" width="180">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>是否符合</span>
                    </template>
                    <template slot-scope="scope">
                        <el-radio v-model="scope.row.qualificationFlag" label="符合">符合</el-radio>
                        <el-radio v-model="scope.row.qualificationFlag" label="不符合">不符合</el-radio>
                    </template>
                </el-table-column>
                <el-table-column prop="sm" label="说明"></el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="title-container">
                <span class="title">能力评估</span>
                <div class="sub-title">1、注册资金</div>
            </div>
            <el-table :data="operationTableData" :span-method="opArraySpanMethod" border header-row-class-name="header-bg">
                <el-table-column prop="pgwd" label="评估维度" width="200"></el-table-column>
                <el-table-column prop="pfbz" label="评分标准">
                    <template slot-scope="scope">
                        <div style="white-space: pre-wrap;">{{ scope.row.pfbz }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="sub-title">2、运营能力</div>
            <el-table :data="riskTableData" :span-method="riArraySpanMethod" border header-row-class-name="header-bg">
                <el-table-column prop="pgwd" label="评估维度" width="220"></el-table-column>
                <el-table-column prop="pfbz" label="评分标准">
                    <template slot-scope="scope">
                        <div style="white-space: pre-wrap;">{{ scope.row.pfbz }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="sub-title">3、运作方案</div>
            <el-table :data="serviceTableData" :span-method="svArraySpanMethod" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="pgwd" label="评估维度" width="170"></el-table-column>
                <el-table-column prop="pfbz" label="评分标准">
                    <template slot-scope="scope">
                        <div style="white-space: pre-wrap;">{{ scope.row.pfbz }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" placeholder="输入分数"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="sub-title">4、抗风险能力</div>
            <el-table :data="kfxTableData" :span-method="svArraySpanMethod" border header-row-class-name="header-bg" class="margin-bottom-20">
                <el-table-column prop="pgwd" label="评估维度" width="170"></el-table-column>
                <el-table-column prop="pfbz" label="评分标准">
                    <template slot-scope="scope">
                        <div style="white-space: pre-wrap;">{{ scope.row.pfbz }}</div>
                    </template>
                </el-table-column>
                <el-table-column prop="zf" label="总分" width="100"></el-table-column>
                <el-table-column prop="df" label="金额/得分" width="100">
                    <template slot="header" slot-scope="scope">
                        <span class="required">*</span><span>金额/得分</span>
                    </template>
                    <template slot-scope="scope">
                        <el-input maxlength="8" :class="scoreError(scope.row.df, scope.row.zf) ? 'is-error' : ''" v-model.trim="scope.row.df" :placeholder="scope.$index > 0 ? '输入分数' : '金额(万)'"></el-input>
                    </template>
                </el-table-column>
                <el-table-column prop="resultFlag" label="结果" width="100"></el-table-column>
            </el-table>
            <div class="require-title">评审要求</div>
            <div class="require-rule margin-bottom-20">1、评审规则：资质信息任一项不符合不得引入；注册资金少于1.5分不得引入；运营能力、运作能方案、抗风险能力低于该项总分80%不得引入。</div>
        </div>
        <span slot="footer" class="dialog-footer">
            <el-button :disabled="confirmLoading || pdfTransforming" @click="close">取 消</el-button>
            <el-button type="primary" :loading="confirmLoading || pdfTransforming" @click="confirm">确认提交</el-button>
            <!-- <el-button @click="generateAndUploadPDF('供应商评分表-运输【法人】.pdf')">生成PDF并上传</el-button> -->
        </span>
    </el-dialog>
</template>
<script>
import Decimal from 'decimal.js'
import BaseInfo from './BaseInfo.vue'
import scoreMixin from './scoreMixin.js';
import { onlineDetail, onlineSave } from '../../../../../../api/qualification.js';

// SRM_BASIC_QUALITY 供应商评分表-装卸
const TYPE = '41'

const INIT_QT = [
    { businessType: '装卸', propertyNature: '法人', zzlx: '营业执照/法人身份证/股东信息登记表', qualificationFlag: '', sm: '原则上此项中任何一条不符合不得引入。有特殊需求需走供应商特批引入。', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '一般纳税人，注册资金超过50万元，开具6%的仓储服务业增值税专用发票', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '无拖欠工人工资及设备租金等不诚信记录；', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '无堵门、客户重大投诉、贿赂员工、黑名单等不良记录；', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '具有家电等相应产品的仓储装卸管理经验且有现成在运行的仓储管理项目', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '具备一般纳税人资格,开具6%的增值税专用发票；', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '必须提供集团亲属关系盖章表，无盖章表或无法说明原因者不得引入', qualificationFlag: '', sm: '', resultFlag: '' },
    { businessType: '', propertyNature: '', zzlx: '具备物流服务资质或相应的经营范围，在合同签订时须提供《营业执照》、《税务登记证》、《组织机构代码证》和法人《身份证》等复印件；', qualificationFlag: '', sm: '', resultFlag: '' },
]

const INIT_OT = [
    { pgwd: '注册资金要求不低于50万元；', pfbz: '注册资金超过500万元得5分，每少100万元扣1分，要求起码得0.5分', zf: '5', df: '', resultFlag: '' },
    { pgwd: '注册年限不低于1年；', pfbz: '注册年限超过5年的得5分，每少1年扣1分，要求起码得1分', zf: '5', df: '', resultFlag: '' },
]
const INIT_RT = [
    { pgwd: '具有类似产品的仓储管理经验；', pfbz: '1、无类似产品的仓储管理经验：0分\n2、有其他产品的仓储管理经验：2分\n3、有类似产品的仓储管理经验\n1-5万平米 4分；5-20万平米 6分；20-50万平米 8分；50万平米以上  10分；', zf: '10', df: '', resultFlag: '' },
    { pgwd: '有现成在运行的仓储管理项目；', pfbz: '1、无现成在运行的仓储管理项目：0分\n2、有现成在运行的仓储管理项目\n0.5-2万平米 2分；2-5万平米 4分；5-10万平米 6分； 0-20万平米 8分； 20万平米以上 10分', zf: '10', df: '', resultFlag: '' },
    { pgwd: '仓储管理制度及管理体系完善', pfbz: '1、有相关仓储管理制度：2分；\n2、有相关品质管理制度：2分；\n3、有相关质量认证证书：2分；', zf: '6', df: '', resultFlag: '' },
    { pgwd: '具备良好的信誉度和声誉度；', pfbz: '1年内获得的客户表扬信或嘉奖通：2分（仓储）\n2年内公司获得的荣誉或奖项：2分（仓储）', zf: '4', df: '', resultFlag: '' },
    { pgwd: '具有仓储管理系统、先进作业工具及IT团队；', pfbz: '具有仓储管理系统：2分；\n具有研发IT团队：2分；\n运用先进作业工：1分；', zf: '5', df: '', resultFlag: '' },
]
const INIT_ST = [
    { pgwd: '运作方案可行性；', pfbz: '1、可提供详细的业务交接方案：2分\n2、可提供完整的入库管理流程：2分\n3、可提供完整的出库管理流程：2分\n4、可提供现场管理方案：2分\n5、可提供账务管理方案：2分\n6、可提供装卸管理方案：2分\n7、可提供品质服务保障方案：2分\n8、可提供旺季作业保障方案：2分', zf: '16', df: '', resultFlag: '' },
    { pgwd: '运作方案创新性；', pfbz: '1、有作业流程创新方案：4分\n2、有先进作业工具引入：4分\n3、有系统优化创新提升效率：4分', zf: '12', df: '', resultFlag: '' },
    { pgwd: '人员转编可行性；', pfbz: '1、人员转编方案：2分\n2、吸引员工的亮点措施：4分\n3、员工平均工龄40岁以下：4分\n4、提供本地化社保方案：2分', zf: '12', df: '', resultFlag: '' },
]
const INIT_KF = [
    { pgwd: '运作保证金***万元；', pfbz: '必要条件，不符合则淘汰', zf: '-', df: '', resultFlag: '' },
    { pgwd: '仓储人员数量；', pfbz: '仓储员工总数量（含装卸）：\n10-50人 2分；50-100人 4分；100-500人 6分；500-1000人 8分；1000人以上 10分', zf: '10', df: '', resultFlag: '' },
    { pgwd: '仓储设备数量；', pfbz: '机动叉车设备总数量：\n5-10台 1分；10-50台 2分；50-100台 3分；100-500台 4分；500台以上 5分', zf: '5', df: '', resultFlag: '' },
]

export default {
    components: { BaseInfo },
    mixins: [scoreMixin],
    data() {
        return {
            // SRM_YES,
            // currentId: null,
            // currentVersion: null,
            currentRow: null,
            visible: false,
            loading: false,
            confirmLoading: false,
            // pdfTransforming: false,

            qlfTableData: JSON.parse(JSON.stringify(INIT_QT)),
            operationTableData: JSON.parse(JSON.stringify(INIT_OT)),
            riskTableData: JSON.parse(JSON.stringify(INIT_RT)),
            serviceTableData: JSON.parse(JSON.stringify(INIT_ST)),
            kfxTableData: JSON.parse(JSON.stringify(INIT_KF)),
        };
    },
    methods: {
        open(row) {
            this.currentRow = row
            this.setUploadQlfForm(row)
            this.visible = true
            this.loading = true
            onlineDetail({ supplierCode: row.qualificationTypeCode, id: row.id }).then(res => {
                if (res && +res.code === 0) {
                    this.setData(res.data, JSON.parse(res.data.onlineContent || null))
                }
            }).finally(() => { this.loading = false })
        },
        close() {
            this.visible = false
            this.$refs.biRef.reset()
            this.qlfTableData = JSON.parse(JSON.stringify(INIT_QT))
            this.operationTableData = JSON.parse(JSON.stringify(INIT_OT))
            this.riskTableData = JSON.parse(JSON.stringify(INIT_RT))
            this.serviceTableData = JSON.parse(JSON.stringify(INIT_ST))
            this.kfxTableData = JSON.parse(JSON.stringify(INIT_KF))
        },
        setData(baseInfo, data) {
            this.$refs.biRef.setBaseInfo(baseInfo)
            if (!data) {
                return false
            }
            this.$refs.biRef.setFormData(data.supplierInfo)
            this.qlfTableData[0].resultFlag = data.supplierQualification.resultFlag
            this.qlfTableData.forEach((item, index) => {
                item.qualificationFlag = data.supplierQualification['qualification' + (index + 1) + 'Flag']
            })
            this.operationTableData[0].resultFlag = data.registerInfo.resultFlag
            this.operationTableData.forEach((item, index) => {
                item.df = data.registerInfo['register' + (index + 1) + 'Score']
            })
            this.riskTableData[0].resultFlag = data.operationalCapability.resultFlag
            this.riskTableData.forEach((item, index) => {
                item.df = data.operationalCapability['risk' + (index + 1) + 'Score']
            })
            this.serviceTableData[0].resultFlag = data.operationalPlan.resultFlag
            this.serviceTableData.forEach((item, index) => {
                item.df = data.operationalPlan['plan' + (index + 1) + 'Score']
            })
            this.kfxTableData[0].resultFlag = data.antiRiskCapability.resultFlag
            this.kfxTableData.forEach((item, index) => {
                item.df = data.antiRiskCapability['anti' + (index + 1) + 'Score']
            })
        },
        confirm() {
            const supplierInfo = this.$refs.biRef.getData()
            // 资质信息-是否符合-必填校验
            const qlfValid = this.qlfTableData.every(item => !!item.qualificationFlag)
            const scoreValid = this.scoreValidate()
            if (supplierInfo && qlfValid && scoreValid) {
                this.generateAndUploadPDF(this.currentRow.qualificationName + '.pdf', () => {
                    this.confirmLoading = true
                    onlineSave(this.getParams()).then(res => {
                        if (res && +res.code === 0) {
                            this.$message.success('提交成功!')
                            this.$emit('submit', this.getParamsFromUpload())
                            this.close()
                        }
                    }).finally(() => { this.confirmLoading = false })
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: '请输入必填信息，字长不能超过20位(通讯地址100位)，得分列请输入0或正整数!',
                    duration: 4000,
                })
            }
        },
        // 所有得分项格式校验
        scoreValidate() {
            const oError = this.operationTableData.some(item => this.scoreError(item.df, item.zf))
            const rError = this.riskTableData.some(item => this.scoreError(item.df, item.zf))
            const sError = this.serviceTableData.some((item, index) => this.scoreError(item.df, item.zf))
            const kError = this.kfxTableData.some((item, index) => this.scoreError(item.df, item.zf))
            return !oError && !rError && !sError && !kError
        },
        getParams() {
            const params = {
                type: TYPE,
                onlineContent: '',
                ...this.getParamsFromUpload()
            }
            const supplierInfo = this.$refs.biRef.getData()
            const supplierQualification = {
                resultFlag: this.qlfTableData[0].resultFlag,
            }
            this.qlfTableData.forEach((item, index) => {
                supplierQualification['qualification' + (index + 1) + 'Flag'] = item.qualificationFlag
            })
            const registerInfo = {
                resultFlag: this.operationTableData[0].resultFlag,
            }
            this.operationTableData.forEach((item, index) => {
                registerInfo['register' + (index + 1) + 'Score'] = item.df
            })
            const operationalCapability = {
                resultFlag: this.riskTableData[0].resultFlag,
            }
            this.riskTableData.forEach((item, index) => {
                operationalCapability['risk' + (index + 1) + 'Score'] = item.df
            })
            const operationalPlan = {
                resultFlag: this.serviceTableData[0].resultFlag,
            }
            this.serviceTableData.forEach((item, index) => {
                operationalPlan['plan' + (index + 1) + 'Score'] = item.df
            })
            const antiRiskCapability = {
                resultFlag: this.kfxTableData[0].resultFlag,
            }
            this.kfxTableData.forEach((item, index) => {
                antiRiskCapability['anti' + (index + 1) + 'Score'] = item.df
            })
            
            params.onlineContent = JSON.stringify({ supplierInfo,supplierQualification, registerInfo, operationalCapability, operationalPlan, antiRiskCapability})
            return params
        },
        arraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if ([0, 1, 4, 5].includes(columnIndex)) {
                if (rowIndex === 0) {
                    return [8, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        opArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 4) {
                if (rowIndex === 0) {
                    return [2, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        riArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 4) {
                if (rowIndex === 0) {
                    return [5, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        svArraySpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 4) {
                if (rowIndex === 0) {
                    return [3, 1];
                } else {
                    return [0, 0];
                }
            }
        },
        isError(val) {
            return ['', null, undefined].includes(val)
        },
        scoreError(score, max) {
            // 非0或正整数 || 大于最大值
            return !/^\+?[0-9][0-9]*$/.test(score) || Number(score) > Number(max)
        },
    },
    watch: {
        qlfTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                val[0].resultFlag = val.some(item => !item.qualificationFlag || item.qualificationFlag === '不符合') ? '不通过' : '通过'
            },
            deep: true,
        },
        operationTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                
                const total = val.reduce((t,v) => {
                    t.df += Number(this.scoreError(v.df, v.zf) ? 0 : v.df)
                    t.zf += Number(v.zf)
                    return t
                }, {df: 0, zf: 0})
                val[0].resultFlag = total.df >= 1.5 ? '通过' : '不通过'
            },
            deep: true,
        },
        riskTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                const total = val.reduce((t,v) => {
                    t.df += Number(this.scoreError(v.df, v.zf) ? 0 : v.df)
                    t.zf += Number(v.zf)
                    return t
                }, {df: 0, zf: 0})
                val[0].resultFlag = total.df >= Decimal.mul(total.zf, 0.8).toNumber() ? '通过' : '不通过'
            },
            deep: true,
        },
        serviceTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                const total = val.reduce((t,v) => {
                    t.df += Number(this.scoreError(v.df, v.zf) ? 0 : v.df)
                    t.zf += Number(v.zf)
                    return t
                }, {df: 0, zf: 0})
                val[0].resultFlag = total.df >= Decimal.mul(total.zf, 0.8).toNumber() ? '通过' : '不通过'
            },
            deep: true,
        },
        kfxTableData: {
            handler(val) {
                if (!this.visible) {
                    return val[0].resultFlag = ''
                }
                const total = val.reduce((t,v,i) => {
                    if(i>0){
                        t.df += Number(this.scoreError(v.df, v.zf) ? 0 : v.df)
                        t.zf += Number(v.zf)
                    }
                    return t
                }, {df: 0, zf: 0})
                val[0].resultFlag = (total.df >= Decimal.mul(total.zf, 0.8).toNumber() && Number(val[0].df) > 0) ? '通过' : '不通过'
            },
            deep: true,
        },
    },
}
</script>
<style lang="less">
.key-data-trans-legal-dialog {
    .el-dialog {
        margin-bottom: 0;
    }

    .el-dialog__body {
        overflow-y: scroll;
        padding: 0;
        height: calc(94vh - 113px);
        box-sizing: border-box;
    }

    .content-wrap {
        padding: 16px;
    }

    .title-container {
        // margin-bottom: 5px;
        font-size: 16px;
        color: #000;

        // i {
        //     float: right;
        //     padding-right: 10px;
        //     font-size: 24px;
        //     cursor: pointer;
        // }
    }

    .title {
        display: inline-block;
        font-weight: bold;

        &::before {
            display: inline-block;
            // border-radius: 50%;
            margin-right: 5px;
            width: 5px;
            height: 14px;
            background: #000;
            content: '';
            vertical-align: middle;
        }
    }

    .sub-title {
        padding: 5px 10px;
        font-size: 14px;
        color: #000;
        background-color: #f2f2f2;
    }

    .el-table {
        // border-right: 1px solid #ebeef5;

        .cell {
            white-space: normal;
        }

        .header-bg th {
            background: #f5f7fa;
        }
    }

    .margin-bottom-20 {
        margin-bottom: 20px;
    }

    .require-title {
        font-size: 16px;
        color: #000;
    }

    .el-dialog__footer {
        padding-top: 15px;
        padding-bottom: 15px;
        text-align: center;
        border-top: 1px solid #d7d7d7;

        .el-button + .el-button {
            margin-left: 30px;
        }
    }

    .required {
        color: #f96c5f;
    }

    .is-error input {
        border-color: #f96c5f;
    }
}
</style>